import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const getInfo = async (cargo_id) => {
  return await httpClient.get(
    `/mass_product_approval/info/?filter[cargo]=${cargo_id}`,
  );
};

const getSummary = async (cargo_id, pago_num) => {
  return await httpClient.get(
    `/mass_product_approval/summary/?filter[cargo]=${cargo_id}&filter[pago_numero]=${pago_num}`,
  );
};

const getSTSummary = async (cargo_id, pago_num) => {
  return await httpClient.get(
    `/mass_product_approval/st_summary/?filter[cargo]=${cargo_id}&filter[pago_numero]=${pago_num}`,
  );
};

const get = async (id) => {
  return await httpClient.get(`/mass_product_approval/${id}/`);
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `mass_product_approval/export/?filter[cargo]=${query}${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `mass_product_approval/?filter[cargo]=${query}&page[number]=${page}&page[size]=${pageSize}${searchBy}`,
    );
};

const contractsTable = async (
  query = {},
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  const params = makeFilterParams(query).params;
  params['page[number]'] = page;
  params['page[size]'] = pageSize;
  if (search) params['filter[search]'] = search;

  return await httpClient.get(
    exportCSV
      ? 'mass_product_approval_contracts/export/'
      : 'mass_product_approval_contracts/',
    {
      params: params,
      responseType: exportCSV ? 'blob' : null,
    },
  );
};

const downloadRegularFile = async (data) => {
  return await httpClient.post(
    `/mass_product_approval/get_regular_file/`,
    data,
    {
      responseType: 'blob',
    },
  );
};

const uploadRegularFile = async (data) => {
  return await httpClient.post(
    `/mass_product_approval/upload_regular_file/`,
    data,
  );
};

const downloadIrregularFile = async (data) => {
  return await httpClient.post(
    `/mass_product_approval/get_irregular_file/`,
    data,
    {
      responseType: 'blob',
    },
  );
};

const uploadIrregularFile = async (data) => {
  return await httpClient.post(
    `/mass_product_approval/upload_irregular_file/`,
    data,
  );
};

const deleteFile = async (id) => {
  return await httpClient.delete(`/mass_product_approval/${id}/`);
};

const downloadAssignedFile = async (id) => {
  return await httpClient.get(
    `/mass_product_approval/${id}/get_assigned_file/`,
  );
};

const downloadReviewedFile = async (id) => {
  return await httpClient.get(
    `/mass_product_approval/${id}/get_reviewed_file/`,
    {
      responseType: 'blob',
    },
  );
};

const assignFile = async (id) => {
  return await httpClient.post(`/mass_product_approval/${id}/assign_file/`);
};

export {
  getInfo,
  getSummary,
  getSTSummary,
  get,
  ajaxTable,
  contractsTable,
  downloadRegularFile,
  uploadRegularFile,
  deleteFile,
  downloadAssignedFile,
  downloadReviewedFile,
  assignFile,
  downloadIrregularFile,
  uploadIrregularFile,
};
